import React, { Fragment, useState } from "react";
import { FaEdit, FaEye } from "react-icons/fa";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { updateDocumentByID } from "apis/customApiHandler";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import { convertToIndianTimezoneAndGetDate } from "utils/helpers";
import permissions from "utils/permissionConstants";
import EditUser from "./editUser";

export const capitalize = (str) =>
  str?.replace(/\b\w/g, (char) => char.toUpperCase()) || "";

const ViewUserList = ({ user, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [togglingActive, setTogglingActive] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const queryClient = useQueryClient();
  const canManageUsers = checkPermission([permissions.manage_users], currentUser);

  const handleToggleActive = async () => {
    setTogglingActive(true);
    try {
      const result = await updateDocumentByID("user", user._id, {
        active: !user.active,
      });
      if (result) {
        toast.success(`User ${user.active ? "deactivated" : "activated"} successfully`);
        queryClient.invalidateQueries("users");
      }
    } finally {
      setTogglingActive(false);
    }
  };

  return (
    <Fragment>
      <tr key={user._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{index + 1}</TD>
        <TD>{user.name}</TD>
        <TD>{user.email}</TD>
        <TD>{user.phone}</TD>
        <TD>{user?.userRole?.name}</TD>
        <TD>
          <div className="flex items-center gap-2">
            <button
              type="button"
              role="switch"
              aria-checked={user.active}
              disabled={!canManageUsers || togglingActive}
              onClick={handleToggleActive}
              className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                user.active ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  user.active ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
            <span
              className={`text-xs font-medium ${
                user.active ? "text-green-600" : "text-gray-500"
              }`}
            >
              {user.active ? "Active" : "Inactive"}
            </span>
          </div>
        </TD>
        <TD>
          {user.createdAt ? new Date(user.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-') : ""}
        </TD>
        <TD>
          {user.lastLogin ? convertToIndianTimezoneAndGetDate(user.lastLogin, true) : ""}
        </TD>
        <TD className="text-sm text-gray-700 font-medium text-center">
          {user.lastUpdatedBy ? capitalize(user.lastUpdatedBy) : ""}
        </TD>
        <TD>
          {canManageUsers ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditUser
          data={user}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditUser data={user} handleClick={() => setShowEditModel(false)} />
      )}
    </Fragment>
  );
};

export default ViewUserList;
